import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

type PhoneNumberFieldProps = {
  isError?: boolean;
  onChange: (v: string) => void;
  onBlur?: (event: React.FocusEvent<HTMLElement>) => void;
  value: string;
  disabled?: boolean;
  label?: string;
  placeholder?: string;
  error?: string;
}

const PhoneNumberField: React.FC<PhoneNumberFieldProps> = ({
  isError,
  onChange,
  value,
  disabled = false,
  label,
  placeholder,
  error,
  onBlur,
}) => {

  return (
    <>
      <label className=" font-bold uppercase text-xs">
        {label && label}
        <PhoneInput
          className="input-lg py-0"
          defaultCountry="CA"
          numberInputProps={{
            className: 'ml-1 py-2 text-base font-bold'
          }}
          value={value}
          placeholder={placeholder}
          onChange={e => {
            if (e) {
              onChange(e);
            }
          }}
          data-testid="phoneNumberField"
          disabled={disabled}
          onBlur={onBlur}
          countrySelectProps={{
            tabindex: -1
          }}
        />
        {isError && (
          <span className="error text-xs">
            {error || 'Phone number is missing or invalid'}
          </span>
        )}
      </label>
    </>
  );
};

export default PhoneNumberField;
